export enum StripeOnboardingStatus {
  NotStarted = 'NotStarted',
  Submitted = 'Submitted',
  Enabled = 'Enabled',
  Restricted = 'Restricted',
}
